import { render } from "./Carto.vue?vue&type=template&id=79a4d81b"
import script from "./Carto.vue?vue&type=script&lang=js"
export * from "./Carto.vue?vue&type=script&lang=js"
script.render = render

export default script